import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import store from './store/store'
import { msalInstance } from './config/authConfig'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

// Initialize MSAL and process any redirect response once before rendering
async function bootstrap (): Promise<void> {
  await msalInstance.initialize()
  await msalInstance.handleRedirectPromise()

  root.render(
    <BrowserRouter>
      <Provider store={store}>
          <App />
      </Provider>
    </BrowserRouter>
  )
}

void bootstrap()
